var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9156 13.0015C24.6095 12.9995 31.3038 12.9995 37.9985 13.0015C38.0005 15.1653 38.0005 17.3286 37.9985 19.4916C31.3044 19.4936 24.6102 19.4936 17.9156 19.4916C17.9135 17.3279 17.9135 15.1645 17.9156 13.0015Z",
    fill: "#02A6C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0084 21.9332C12.168 21.922 14.328 21.922 16.4883 21.9332C16.4995 24.0928 16.4995 26.2528 16.4883 28.4131C14.3281 28.4243 12.1681 28.4244 10.0084 28.4137C9.9972 26.2537 9.9972 24.0936 10.0084 21.9332Z",
    fill: "#5FCADE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9206 21.933C22.7522 21.9227 27.5834 21.9227 32.4142 21.933C32.4245 24.0926 32.4245 26.2526 32.4142 28.4129C27.5828 28.423 22.7516 28.423 17.9206 28.4129C17.9106 26.2532 17.9106 24.0932 17.9206 21.933Z",
    fill: "#5FCADE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9267 30.8667C20.0827 30.8433 22.2383 30.8433 24.3935 30.8667C24.4159 33.0213 24.4162 35.1769 24.3944 37.3335C22.2385 37.3548 20.0829 37.3544 17.9278 37.3324C17.9054 35.178 17.905 33.0228 17.9267 30.8667Z",
    fill: "#ABEBF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtt);
export default __webpack_public_path__ + "static/media/ftt.912e24f659358a0ecbda44835f1899f3.svg";
export { ForwardRef as ReactComponent };